// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Searchable `Notice's` values for type=ATTRIBUTE. Relates to `ServiceJourney::notices`.<br>x-extensible-enum: 
 * - `TripsByOriginAndDestinationPostBody::includeNoticeAttributes`: all values supported and also applied in related `vias` except COUCHETTE/SLEEPING_CAR
 * - `ServiceCalendarByOriginAndDestinationRequestBody::includeNoticeAttributes`: only 'BIKE_TRANSPORT' supported yet
 * @export
 */
export const NoticeAttributeEnum = {
    GroupsAdmitted: 'GROUPS_ADMITTED',
    BikeTransport: 'BIKE_TRANSPORT',
    Couchette: 'COUCHETTE',
    SleepingCar: 'SLEEPING_CAR',
    ExcludeTiltingTrain: 'EXCLUDE_TILTING_TRAIN'
} as const;
export type NoticeAttributeEnum = typeof NoticeAttributeEnum[keyof typeof NoticeAttributeEnum];


export function instanceOfNoticeAttributeEnum(value: any): boolean {
    for (const key in NoticeAttributeEnum) {
        if (Object.prototype.hasOwnProperty.call(NoticeAttributeEnum, key)) {
            if (NoticeAttributeEnum[key as keyof typeof NoticeAttributeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NoticeAttributeEnumFromJSON(json: any): NoticeAttributeEnum {
    return NoticeAttributeEnumFromJSONTyped(json, false);
}

export function NoticeAttributeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoticeAttributeEnum {
    return json as NoticeAttributeEnum;
}

export function NoticeAttributeEnumToJSON(value?: NoticeAttributeEnum | null): any {
    return value as any;
}

export function NoticeAttributeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): NoticeAttributeEnum {
    return value as NoticeAttributeEnum;
}

